import React, { useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import newsData from "../../../data/newsData";
import { getLatestNews } from "../../../utils/newsHelpers";
import NewsCard from "../../cards/NewsCard/NewsCard";
import "./NewsSection.css";

export default function NewsSection() {
    const { i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith("ar");

    const latestNews = useMemo(() => getLatestNews(newsData, 10), []);
    const shouldUseSlider = latestNews.length > 4;

    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: latestNews.length > 4,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        rtl: isArabic,
    };

    const { t } = useTranslation();

    return (
        <section className="news section-spacing section-bg">
            <div className="text-center">
                <SectionTitle
                    subtitle={t("common.sectionTitles.newsSecSubtitle")}
                    title={t("common.sectionTitles.newsSecTitle")}
                    align="left"
                />
                <p className="brand-section-desc">
                    {t("common.staticTexts.newsSecTagline")}
                </p>
            </div>

            <section className="news-section">
                <Container fluid>
                    {!shouldUseSlider ? (
                        <Row className="g-4">
                            {latestNews.map((item) => (
                                <Col key={item.id} xl={3} lg={3} md={6} sm={6} xs={12}>
                                    <NewsCard item={item} layout="grid" />
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <div className="news-section__slider-wrap">
                            <Slider {...sliderSettings}>
                                {latestNews.map((item) => (
                                    <div key={item.id} className="news-section__slide">
                                        <div className="news-section__slide-inner">
                                            <NewsCard item={item} layout="grid" />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    )}

                    <div className="news-section__bottom-link">
                        <Link to="/news" className="lk-brand-link">
                            {isArabic ? "عرض جميع الأخبار" : "View All News"}
                        </Link>
                    </div>
                </Container>
            </section>


        </section>
    );
}